module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ClanInfoPanel/images/pattern-left.5e767129.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ClanInfoPanel/images/pattern-left.jpg
// module id = 3267
// module chunks = 11